/* Pawsy storefront script: drawers, cart, countdown, carousels, reveals.
   No dependencies. Sections call window.pawsy.addToCart(items) to add lines
   and open the drawer. */
(function () {
  'use strict';
  var P = (window.pawsy = window.pawsy || {});
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };

  /* ---------- money ---------- */
  P.money = function (cents) {
    var fmt = P.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    var with2 = function (sep, dec) {
      var p = n.toFixed(2).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + dec + p[1];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return with2('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return with2(',', '.');
    });
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- drawers ---------- */
  var backdrop = $('[data-ps-backdrop]');
  var nav = $('#ps-nav');
  var cart = $('#ps-cart');
  var lastFocus = null;

  function open(el) {
    closeAll(true);
    if (!el) return;
    lastFocus = doc.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    backdrop && backdrop.classList.add('is-open');
    doc.documentElement.style.overflow = 'hidden';
    $$('[data-ps-nav-open]').forEach(function (b) { b.setAttribute('aria-expanded', el === nav ? 'true' : 'false'); });
    var f = el.querySelector('button, a[href]');
    f && setTimeout(function () { f.focus({ preventScroll: true }); }, 50);
  }
  function closeAll(silent) {
    [nav, cart].forEach(function (el) { if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); } });
    backdrop && backdrop.classList.remove('is-open');
    doc.documentElement.style.overflow = '';
    $$('[data-ps-nav-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  P.openCart = function () { return refreshCart().then(function () { open(cart); }); };
  P.closeDrawers = closeAll;

  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ps-nav-open], [data-ps-cart-open], [data-ps-close], [data-ps-backdrop]');
    if (!t) return;
    if (t.hasAttribute('data-ps-nav-open')) { e.preventDefault(); open(nav); }
    else if (t.hasAttribute('data-ps-cart-open')) { if (!cart) return; e.preventDefault(); P.openCart(); }
    else { if (t.tagName === 'A') e.preventDefault(); closeAll(); }
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart ---------- */
  var freeShip = (P.freeShipVariants || []).map(Number);
  var isGift = function (it) { return it.product_type === 'free_gift' || (it.properties && it.properties._is_free_gift); };

  function renderCart(c) {
    P.cart = c;
    $$('[data-ps-cart-count]').forEach(function (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
    if (!cart) return;
    var d = cart.dataset;
    var list = $('[data-ps-cart-items]', cart);
    var foot = $('[data-ps-cart-foot]', cart);
    var timer = $('[data-ps-timer]', cart);
    if (!c.items.length) {
      list.innerHTML = '<li class="ps-cart__empty"><p>' + esc(d.tEmpty) + '</p><a href="#" data-ps-close>' + esc(d.tContinue) + '</a></li>';
      foot.hidden = true; if (timer) timer.hidden = true;
      return;
    }
    foot.hidden = false; if (timer) timer.hidden = false;
    list.innerHTML = c.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var free = it.final_line_price === 0;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var plan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : '';
      var gift = isGift(it);
      var linkable = !gift && /^\/products\/pawsy-(?!gift-)/.test(it.url || '');
      var imgTag = img ? '<img class="ps-cart__img" src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : '<span class="ps-cart__img"></span>';
      return '<li class="ps-cart__item" data-line="' + (i + 1) + '">' +
        (linkable ? '<a href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + imgTag + '</a>' : '<span aria-hidden="true">' + imgTag + '</span>') +
        '<div>' + (linkable ? '<a class="ps-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' : '<span class="ps-cart__name">' + esc(it.product_title) + '</span>') +
        (variant ? '<p class="ps-cart__variant">' + esc(variant) + '</p>' : '') +
        (plan ? '<p class="ps-cart__variant">' + esc(plan) + '</p>' : '') +
        (gift ? '' :
          '<div class="ps-cart__qty"><button type="button" data-qty="-1" aria-label="-">&minus;</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="+">+</button></div>') +
        '<button type="button" class="ps-cart__remove" data-remove>' + esc(d.tRemove) + '</button></div>' +
        '<div class="ps-cart__price">' +
          (it.original_line_price > it.final_line_price ? '<s>' + P.money(it.original_line_price) + '</s>' : '') +
          (free ? '<span class="ps-cart__free">' + esc(d.tFree) + '</span>' : P.money(it.final_line_price)) +
        '</div></li>';
    }).join('');

    var disc = $('[data-ps-cart-discounts]', cart);
    disc.innerHTML = (c.cart_level_discount_applications || []).map(function (a) {
      return '<div class="ps-cart__discount"><span>' + esc(a.title) + '</span><span>&minus;' + P.money(a.total_allocated_amount) + '</span></div>';
    }).join('');
    $('[data-ps-cart-total]', cart).textContent = P.money(c.total_price) + ' ' + (c.currency || '');

    // Shipping is free only when every non-gift line is a 3-pack (the $0 profile).
    var paid = c.items.filter(function (it) { return !isGift(it); });
    var fs = paid.length > 0 && paid.every(function (it) { return freeShip.indexOf(it.variant_id) !== -1; });
    $('[data-ps-cart-freeship]', cart).hidden = !fs;
    $('[data-ps-cart-note]', cart).textContent = fs ? d.tTaxesOnly : d.tTaxesShipping;
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function change(line, quantity) {
    cart && cart.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (c) {
      // Removing the last paid line leaves its gifts behind; clear them too.
      var paid = c.items.filter(function (it) { return !isGift(it); });
      if (!paid.length && c.items.length) {
        return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).then(function (r) { return r.json(); });
      }
      return c;
    }).then(renderCart).finally(function () { cart && cart.classList.remove('is-busy'); });
  }
  cart && cart.addEventListener('click', function (e) {
    var li = e.target.closest('[data-line]');
    if (!li || !P.cart) return;
    var line = +li.dataset.line, it = P.cart.items[line - 1];
    if (e.target.closest('[data-remove]')) change(line, 0);
    else if (e.target.closest('[data-qty]')) change(line, Math.max(0, it.quantity + +e.target.closest('[data-qty]').dataset.qty));
  });

  /* items: [{id, quantity, selling_plan?, properties?}] */
  P.addToCart = function (items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    }).then(function () { return P.openCart(); });
  };

  /* ---------- order-within countdown (to the next 12:00 UTC cutoff) ---------- */
  function tick() {
    var now = new Date();
    var cut = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 12));
    if (now >= cut) cut.setUTCDate(cut.getUTCDate() + 1);
    var s = Math.floor((cut - now) / 1000);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var txt = pad(Math.floor(s / 3600)) + ' : ' + pad(Math.floor(s / 60) % 60) + ' : ' + pad(s % 60);
    $$('[data-ps-timer-value]').forEach(function (el) { el.innerHTML = '<bdi>' + txt + '</bdi>'; });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- carousels ---------- */
  P.initCarousel = function (root) {
    var track = $('[data-ps-track]', root);
    if (!track || track._ps) return;
    track._ps = true;
    var prev = $('[data-ps-prev]', root), next = $('[data-ps-next]', root), dots = $('[data-ps-dots]', root);
    var slides = function () { return Array.prototype.filter.call(track.children, function (c) { return c.offsetParent !== null; }); };
    var rtl = getComputedStyle(track).direction === 'rtl';
    var step = function () { var s = slides(); if (s.length < 2) return track.clientWidth; return Math.abs(s[1].offsetLeft - s[0].offsetLeft); };
    var pages = function () { return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1); };
    var idx = function () { return Math.round(Math.abs(track.scrollLeft) / step()); };
    function update() {
      var i = idx(), n = pages();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      if (dots) {
        if (dots.children.length !== n) dots.innerHTML = new Array(n + 1).join('<span class="ps-carousel__dot"></span>');
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
      }
    }
    var go = function (dir) { track.scrollBy({ left: (rtl ? -1 : 1) * dir * step(), behavior: 'smooth' }); };
    prev && prev.addEventListener('click', function () { go(-1); });
    next && next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    if (root.hasAttribute('data-ps-autoplay')) {
      var ms = +root.getAttribute('data-ps-autoplay') || 4000, hold = false;
      root.addEventListener('pointerenter', function () { hold = true; });
      root.addEventListener('pointerleave', function () { hold = false; });
      setInterval(function () {
        if (hold || doc.hidden) return;
        if (idx() >= pages() - 1) track.scrollTo({ left: 0, behavior: 'smooth' }); else go(1);
      }, ms);
    }
  };

  /* ---------- tabs ---------- */
  P.initTabs = function (root) {
    var tabs = $$('[data-ps-tab]', root), panels = $$('[data-ps-panel]', root);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, k) { x.classList.toggle('is-active', k === i); x.setAttribute('aria-selected', k === i); });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
      });
    });
  };

  /* ---------- reveal on scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function boot(scope) {
    $$('[data-ps-carousel]', scope).forEach(P.initCarousel);
    $$('[data-ps-tabs]', scope).forEach(P.initTabs);
    $$('.ps-reveal', scope).forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
  }
  P.boot = boot;
  boot(doc);
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  // Keep the drawer and counts honest after back/forward navigation.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  if (cart) refreshCart();
})();
